var objDialog = dialog();
var objDom = dom();
var objCustomRoute = customRoute();

/**
 * Object: allowEntities
 * Purpose: Control the availave participant choices in each step.
 */
var allowEntities = function() {
	'use strict';

	var objAllowEntities = {};

	// Click Event for opening the restrict entities dialog.
	$('#curriculog-steps-column').on('click', '#entity-change', function(event) {
		event.preventDefault();
		objAllowEntities.restrictEntityDialog();
	});

	// Click event for choosing an entity.
	$('#curriculog-steps-column-available-entities').on('click', '.entity', function(event) {
		event.preventDefault();
		var itemId = /entity-[0-9]*/i.exec($(this).attr('class'));
		$('.' + itemId).toggleClass('active');
	});

	// Click event for expanding and contracting the list of entities.
	$('#curriculog-steps-column-available-entities').on('click', '.toggle-expand', function(event) {
		event.preventDefault();
		$(this).siblings('ul').toggleClass('active');
	});


	/*
	 * Function: restrictEntityDialog
	 * Purpose: Load a dialog to allow for entities to be chosen.
	 */
	objAllowEntities.restrictEntityDialog = function() {

		//
		var dialog = objDialog.createDOMDialog('curriculog-steps-select-entity', function(dialog, defaults) {

			// Load the list of entities and mark the previously chosen ones.
			$.ajax({
				url: '/admin/entity/hierarchy',
				type: 'GET',
				data: { display: JSON.stringify(['entities']) },
				success: function(data) {

					// Wipe out old data and load in new data.
					$('#curriculog-steps-column-available-entities').contents().remove();
					$('#curriculog-steps-column-available-entities').append(data);

					if($('#curriculog-steps-column-available-entities ul li').length === 0) {
						$('#curriculog-steps-column-available-entities ul').append('<li>You have not defined any hierarchy. Please go to the hierarchy module and enter your hierarchy before completing this approval process.</li>');
					}

					// Prepare for the list of restricted entities.
					var entities = [];

					// Set the list of restricted entities.
					$('#restrict-entities .restricted-entity').each(function(index) {
						var entityId = $(this).children('.hierarchy-item').attr('id').split('-')[1];
						entities.push(entityId);
					});

					// Add an active class to previously restricted entities.
					for (var i in entities) {
						$('#curriculog-steps-column-available-entities #entity-' + entities[i]).addClass('active');
						$('#curriculog-steps-column-available-entities #entity-' + entities[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-entities'), 'ul').addClass('active');
					}

					// Modify the toggle icon appropriately.
					$('#curriculog-steps-column-available-entities ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');

				}

			});

			defaults.buttons = {
				'Done': function() {

					// Prepare for the list of restricted entities.
					var entities = [];

					$('#curriculog-steps-column-available-entities .entity.active').each(function(index) {
						if ($('#restrict-entities').find('#' + $(this).attr('id')).length === 0) {
							entities.push($(this).attr('id'));
						}
					});

					objAllowEntities.warning(entities, function() {
						// Empty the restricted entities list.
						$('#restrict-entities .restricted-entity').remove();

						if ($('#curriculog-steps-column-available-entities .entity.active').length > 0) {
							$('#restrict-entities .no-restricted-entity').removeClass('active');
							$('#restrict-entities .restricted-entity-text').addClass('active');
						} else {
							$('#restrict-entities .no-restricted-entity').addClass('active');
							$('#restrict-entities .restricted-entity-text').removeClass('active');
						}

						// Load in the new restricted entities list.
						$('#curriculog-steps-column-available-entities .entity.active').each(function(index) {
							if ($('#restrict-entities').find('#' + $(this).attr('id')).length === 0) {
								$(this).clone().appendTo($('#restrict-entities')).wrap('<li class="restricted-entity"></li>');
							}
						});

						// Adjust the height of the columns.
						approvalProcessObject.verticalStretch();

						// Save the restricted entities list.
						objAllowEntities.updateRestrictEntity();
					});

					$(this).dialog('close');
				},
				Cancel: function() { $(this).dialog('close');}
			};

			defaults.width = 800;

			$(dialog).dialog(defaults);

		});
	};

	objAllowEntities.warning = function(entities, callback) {

		if (entities.length !== 0) {
			var dialog = objDialog.createBasicWarningDialog('warning-remove-users', function(dialog, defaults) {
				// Message
				$(dialog).append('To restrict your steps by entity, all existing participants must be removed from your steps. ' +
					'You will then be able to select participants from only the entities you have selected. Do you wish to continue?');

				// Actions
				defaults.buttons = {
					'Ok': function() {

						// remove all participants from steps
						$('#steps .step').each(function(index) {
							$(this).find('.curriculog-steps-column-chosen-users').children('li').remove();
							$(this).find('.curriculog-steps-column-chosen-roles').children('li').remove();
							$(this).find('.curriculog-steps-column-chosen-role-types').children('li').remove();
						});

						if (callback) {
							callback();
						}
						$(dialog).dialog('close');
					},
					'Cancel': function() {
						$(dialog).dialog('close');
					}
				};

				defaults.close = function(event, ui) {
					$(this).remove();
				};

				$(dialog).dialog(defaults);
			});
		} else {
			if (callback) {
				callback();
			}
		}
	};


	/*
	 * Function: updateRestrictEntity
	 * Purpose: Loop though the chosen entities to be restricted and pass them to the backend.
	 */
	objAllowEntities.updateRestrictEntity = function() {

		// Set the approval process id.
		var approvalProcessId = $('input[name="id"]').val();

		// Prepare for the list of restricted entities.
		var entities = [];

		// Set the list of restricted entities.
		$('#restrict-entities .restricted-entity').each(function(index) {
			var entityId = $(this).children('.hierarchy-item').attr('id').split('-')[1];
			entities[index] = parseInt(entityId, 10);
		});

		// Update the list of restricted entities.
		$.ajax({
			url: '/admin/approvalProcess:' + approvalProcessId + '/allowedEntities.json',
			type: 'PUT',
			data: { allowedEntities: JSON.stringify(entities) },
			success: function(data) {

			}
		});
	};

	return objAllowEntities;
};










/**
 * Object: selectParticipants
 * Purpose: Choose the participants to be involved on that step.
 */
var selectParticipants = function() {
	'use strict';

	var objSelectParticipants = {};

	// Set the approval process id.
	var approvalProcessId = $('input[name="id"]').val();

	// Click Event for opening the participant dialog.
	$('#curriculog-steps-column-content').on('click', '.step .add-role', function(event) {
		event.preventDefault();
		if ($('#route').length) {
			objSelectParticipants.participantDialog(this, '.curriculog-steps-column-chosen', 'pendingRoute');
		} else {
			objSelectParticipants.participantDialog(this, '.curriculog-steps-column-chosen', 'participants');
		}
	});

	// Click Event for opening the participant dialog for adding notifications.
	$('body').on('click', '.add-deadline-notify', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('.ui-dialog-content').attr('id').replace('-deadlines-dialog', '');
		objSelectParticipants.participantDialog('', '.curriculog-steps-column-chosen-deadline-notifications', 'notifications', stepId.replace('step-', ''));
	});

	// Click Event for opening the participant dialog for adding notifications.
	$('body').on('click', '.add-approve-notify', function(event) {
		event.preventDefault();
		var stepId = $(this).closest('.ui-dialog-content').attr('id').replace('-decisions-dialog', '');
		objSelectParticipants.participantDialog('', '.curriculog-steps-column-chosen-approve-notifications', 'notifications', stepId.replace('step-', ''));
	});

	// Click Event for opening the participant dialog for adding notifications.
	$('body').on('click', '.add-reject-notify', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('.ui-dialog-content').attr('id').replace('-decisions-dialog', '');
		objSelectParticipants.participantDialog('', '.curriculog-steps-column-chosen-reject-notifications', 'notifications', stepId.replace('step-', ''));
	});

	// Click Event for opening the participant dialog for adding notifications.
	$('body').on('click', '.add-condition-notify', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('.ui-dialog-content').attr('id').replace('-mandatory-dialog', '');
		objSelectParticipants.participantDialog('', '.curriculog-steps-column-chosen-mcondition-notifications', 'notifications', stepId.replace('step-', ''));
	});

	$('body').on('click', '.replaceParticipants', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').parents('div').children('.replace-participants-data').attr('id');

		// get ids of roles to not include in the selector
		var roleIds = [];
		$(this).parents('.conflict-resolution-content').children('.conflict-resolution-leftContent')
			.children('.replace-participants-oldData')
			.children('.curriculog-steps-column-chosen-roles')
			.children('li').each(function(index) {
				roleIds.push($(this).children('.role').attr('id').replace('role-', ''));
			});

		objSelectParticipants.participantDialog(this, '.curriculog-steps-column-chosen', 'replace', stepId, roleIds);
	});

	$('body').on('click', '.replaceAllParticipants', function(event) {
		event.preventDefault();
		var stepId = $(this).next('.replace-participants-data').attr('id');

		// get ids of roles to not include in the selector
		var roleIds = [];
		$('#replace-participants-data').find('.conflict-resolution-leftContent').each(function(index) {

			$(this).children('.replace-participants-oldData').children('.curriculog-steps-column-chosen-roles').children('li').each(function(index) {
				if ($.inArray(parseInt($(this).children('.role').attr('id').replace('role-', ''), 10), roleIds) === -1) {
					roleIds.push($(this).children('.role').attr('id').replace('role-', ''));
				}
			});

		});

		objSelectParticipants.participantDialog(this, '.curriculog-steps-column-chosen', 'replaceAll', stepId, roleIds);
	});

	$('body').on('click', '.replaceAllRoleParticipants', function(event) {
		event.preventDefault();
		var stepId = $(this).next('.replace-participants-data').attr('id');

		// get ids of roles to not include in the selector
		var roleIds = [];
		$('#replace-roleParticipants-data').find('.conflict-resolution-leftContent').each(function(index) {

			$(this).children('.replace-participants-oldData').children('.curriculog-steps-column-chosen-roles').children('li').each(function(index) {
				if ($.inArray(parseInt($(this).children('.role').attr('id').replace('role-', ''), 10), roleIds) === -1) {
					roleIds.push($(this).children('.role').attr('id').replace('role-', ''));
				}
			});

		});

		objSelectParticipants.participantDialog(this, '.curriculog-steps-column-chosen', 'replaceAllRoleParticipants', stepId, roleIds, 'replace-roleParticipants-data');
	});

	objSelectParticipants.bindEvents = function() {
		// If this is a custom route, disable the selection of roles without users.
		var participantSelectors;
		if ($('.route').length) {
			participantSelectors = '.role-type, .role:not(.role-without-users), .user';
		} else {
			participantSelectors = '.role-type, .role, .user';
		}

		// Click event for choosing a role-type, role, or user.
		$('#curriculog-steps-select-participant').on('click', participantSelectors, function(event) {
			event.preventDefault();
			var itemId = /role-\d+|user-\d+|role-type-\d+/i.exec($(this).attr('class'));
			$('.' + itemId).toggleClass('active');
		});

		// Click event for expanding and contracting the list of entities, roles, users, and role-types.
		$('#curriculog-steps-column-available-participant').on('click', '.toggle-expand', function(event) {
			event.preventDefault();
			$(this).toggleClass('expand-widget').toggleClass('contract-widget').siblings('ul').toggleClass('active');
		});

	};

	objSelectParticipants.unBindEvents = function() {
		// If this is a custom route, disable the selection of roles without users.
		var participantSelectors;
		if ($('.route').length) {
			participantSelectors = '.role-type, .role:not(.role-without-users), .user';
		} else {
			participantSelectors = '.role-type, .role, .user';
		}

		$('#curriculog-steps-select-participant').off('click', participantSelectors);
		$('#curriculog-steps-column-available-participant').off('click', '.toggle-expand');

	};

	/**
	 * Function: participantDialog
	 * Purpose: Load a dialog to allow for entities, roles, users, and role-types to be chosen.
	 */
	objSelectParticipants.participantDialog = function(editSelector, dataSelector, type, stepId, roleIds, allSelector) {

		// bind click events
		objSelectParticipants.bindEvents();
		var dialogName;
		var step;

		// Set the step Id.
		if (type === 'notifications') {
			// find what kind of notification we are dealing with
			var notificationType = '-' + dataSelector.split('-')[4];

			if (notificationType === '-deadline') {
				dialogName = '-deadlines';
			} else if (notificationType === '-approve' || notificationType === '-reject') {
				dialogName = '-decisions';
			} else if (notificationType === '-mcondition') {
				dialogName = '-mandatory';
			} else {
				dialogName = 'none';
			}

			step = 'step-' + stepId;
			$('#curriculog-steps-select-participant').prop('title', 'Who should we Notify?');
		} else if (type === 'replace' || type === 'replaceAll' || type === 'replaceAllRoleParticipants') {
			step = stepId;
			dialogName = 'none';
		} else {
			dialogName = 'none';
			step = $(editSelector).closest('.step').attr('id');
			$('#curriculog-steps-select-participant').prop('title', 'Who is involved on this step?');
		}


		// Prepare for the list of restricted entities.
		var entities = [];

		// Set the list of restricted entities.
		$('#restrict-entities .restricted-entity').each(function(index) {
			var entityId = $(this).children('.hierarchy-item').attr('id').split('-')[1];
			entities[index] = parseInt(entityId, 10);
		});


		var dialog = objDialog.createDOMDialog('curriculog-steps-select-participant', function(dialog, defaults) {

			// Load the list of role-types and mark the previously chosen ones.
			if (! $('#route').length) {
				$.ajax({
					url: '/roleType',
					type: 'GET',
					data: {
						display: 'ajaxRoleTypeList',
						branch: JSON.stringify(entities)
					},
					success: function(data) {
						//console.log(data);
						// Wipe out old data and load in new data.
						$('#curriculog-steps-column-available-role-types').contents().remove();

						$('#curriculog-steps-column-available-role-types').append(data);

						// Prepare for the list of role-types.
						var roleTypes = [];

						// Set the list of role-types.
						$('#'+ step + ' ' + dataSelector + '-role-types li').each(function(index) {
							var roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[3];

							if (type === 'replace') {
								roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
							} else if (type === 'replaceAll' || type === 'replaceAllRoleParticipants') {
								roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
							}

							// add notifications to id
							if (type === 'notifications') {
								var id = $(this).children('.hierarchy-item').prop('id');
								$(this).children('.hierarchy-item').prop('id', id + notificationType + '-notifications');
							}
							roleTypes.push(roleTypeId);
						});

						// Add an active class to previously selected role-types.
						for (var i in roleTypes) {
							$('#roleType-' + roleTypes[i]).addClass('active');
							$('#roleType-' + roleTypes[i]).parents('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-role-types'), 'ul').addClass('active');
						}

						// Modify the toggle icon appropriately.
						$('#curriculog-steps-column-available-role-types ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');
					}
				});
			}

			// Load the list of entities, roles, and users and mark the previously chosen ones.
			$.ajax({
				url: '/entity/hierarchy',
				type: 'GET',
				data: {
					display: JSON.stringify(['entities', 'roles', 'users']),
					branch: JSON.stringify(entities)
				},
				success: function(data) {
					// Wipe out old data and load in new data.
					$('#curriculog-steps-column-available-roles-and-users').contents().remove();

					$('#curriculog-steps-column-available-roles-and-users').append(data);

					$('#curriculog-steps-column-available-roles-and-users').contents().wrap('<li class="hierarchy-title"></li>');
					$('#curriculog-steps-column-available-roles-and-users').contents().wrap('<ul></ul>');
					$('#curriculog-steps-column-available-roles-and-users .hierarchy-title').prepend('<a class="curriculog-widget expand-widget toggle-expand" href="#"></a><span class="hierarchy-item hierarchy-title"><label>Hierarchy</label></span>').removeAttr('class');

					if(roleIds)
					{
						$.each(roleIds, function(index, roleId) {
							$('#curriculog-steps-select-participant .role-' + roleId).each(function(index) {
								if ($(this).parent('li').parent('ul').children('li').length === 1 && $(this).parent('li').parent('ul').parents('li').children('ul').length === 1) {
									$(this).parent('li').parent('ul').parent('li').children('a').remove();
									$(this).parent('li').parent('ul').remove();
								} else {
									$(this).parent('li').remove();
								}
							});
						});
					}

					// Prepare for the list of roles and users.
					var roles = [];
					var users = [];

					// Set the list of roles and users.
					$('#'+ step + ' ' + dataSelector + '-roles li').each(function(index) {
						var roleId = $(this).children('.hierarchy-item').attr('id').split('-')[3];

						if (type === 'replace') {
							roleId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
						} else if (type === 'replaceAll' || type === 'replaceAllRoleParticipants') {
							roleId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
						}


						// add notifications to id
						if (type === 'notifications') {
							var id = $(this).children('.hierarchy-item').prop('id');
							$(this).children('.hierarchy-item').prop('id', id + notificationType + '-notifications');
						}

						roles.push(roleId);
					});
					$('#'+ step + ' ' + dataSelector + '-users li').each(function(index) {
						var userId = $(this).children('.hierarchy-item').attr('id').split('-')[3];

						if (type === 'replace') {
							userId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
						} else if (type === 'replaceAll' || type === 'replaceAllRoleParticipants') {
							userId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
						}

						// add notifications to id
						if (type === 'notifications') {
							var id = $(this).children('.hierarchy-item').prop('id');
							$(this).children('.hierarchy-item').prop('id', id + notificationType + '-notifications');
						}

						users.push(userId);
					});

					// Add an active class to previously selected roles and users.
					var i;
					for (i in roles) {
						$('#curriculog-steps-column-available-roles-and-users #role-' + roles[i]).addClass('active');
						$('#curriculog-steps-column-available-roles-and-users #role-' + roles[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-roles-and-users'), 'ul').addClass('active');
					}
					for (i in users) {
						$('#curriculog-steps-column-available-roles-and-users #user-' + users[i]).addClass('active');
						$('#curriculog-steps-column-available-roles-and-users #user-' + users[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-roles-and-users'), 'ul').addClass('active');
					}

					// Modify the toggle icon appropriately.
					$('#curriculog-steps-column-available-roles-and-users ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');
				}
			});

			defaults.buttons = {
				'Add Role(s)': function() {

					// Wipe out old data.
					$('#' + step).find(dataSelector + '-role-types').empty();
					$('#' + step).find(dataSelector + '-roles').empty();
					$('#' + step).find(dataSelector + '-users').empty();

					if (dialogName !== 'none') {
						$('#' + step + dialogName + '-dialog .list' + notificationType + '-notifications').empty();
					}

					var notificationList = [];

					// If the chosen hierarchy item dosent already exist then add it to the list.
					$('#curriculog-steps-column-available-participant .role-type.active').each(function(index) {
						var chosenRoleTypeInStep;
						if (type === 'notifications') {
							chosenRoleTypeInStep = step + '-' + $(this).attr('id') + notificationType + '-notifications';
						} else {
							chosenRoleTypeInStep = step + '-' + $(this).attr('id');
						}

						if ($('#' + chosenRoleTypeInStep).length === 0) {
							$(this).clone().attr('id', chosenRoleTypeInStep).appendTo($('#' + step).find(dataSelector + '-role-types')).wrap('<li></li>');

							if (type === 'notifications') {
								$(this).clone().attr('id', chosenRoleTypeInStep).appendTo($('#' + step + dialogName + '-dialog .list' + notificationType + '-notifications')).wrap('<li></li>');
							}
						}
					});
					$('#curriculog-steps-column-available-participant .role.active').each(function(index) {
						var chosenRoleInStep;
						if (type === 'notifications') {
							chosenRoleInStep = step + '-' + $(this).attr('id') + notificationType + '-notifications';
						} else {
							chosenRoleInStep = step + '-' + $(this).attr('id');
						}

						if ($('#' + chosenRoleInStep).length === 0) {
							$(this).clone().attr('id', chosenRoleInStep).appendTo($('#' + step).find(dataSelector + '-roles')).wrap('<li></li>');

							if (type === 'notifications') {
								$(this).clone().attr('id', chosenRoleInStep).appendTo($('#' + step + dialogName + '-dialog .list' + notificationType + '-notifications')).wrap('<li></li>');
							}
						}
					});
					$('#curriculog-steps-column-available-participant .user.active').each(function(index) {
						var chosenUserInStep;
						if (type === 'notifications') {
							chosenUserInStep = step + '-' + $(this).attr('id') + notificationType + '-notifications';
						} else {
							chosenUserInStep = step + '-' + $(this).attr('id');
						}

						if ($('#' + chosenUserInStep).length === 0) {
							$(this).clone().attr('id', chosenUserInStep).appendTo($('#' + step).find(dataSelector + '-users')).wrap('<li></li>');

							if (type === 'notifications') {
								$(this).clone().attr('id', chosenUserInStep).appendTo($('#' + step + dialogName + '-dialog .list' + notificationType + '-notifications')).wrap('<li></li>');
							}
						}
					});

					// Adjust the height of the columns.
					approvalProcessObject.verticalStretch();

					// Save the participant list.
					objSelectParticipants.updateParticipant(step, dataSelector, type, notificationType);

					$(this).dialog('close');
				},
				Cancel: function() { $(this).dialog('close');}
			};

			defaults.close = function() {
				objSelectParticipants.unBindEvents();
			};

			defaults.width = 800;

			$(dialog).dialog(defaults);

		});
	};


	/*
	 * Function: updateParticipant
	 * Purpose: Loop though the chosen roles, users, and role-types and pass them to the backend.
	 */
	objSelectParticipants.updateParticipant = function(stepSelector, dataSelector, type, notificationType) {

		// Set the step Id.
		var stepId = parseInt(stepSelector.split('-')[1], 10);

		// Prepare for the list of role-types, roles, and users.
		var roleTypes = [];
		var roles = [];
		var users = [];


		// Set the list of role-types, roles, and users.
		$('#' + stepSelector).find(dataSelector + '-role-types li').each(function(index) {
			var roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[3];
			roleTypes[index] = parseInt(roleTypeId, 10);
		});
		$('#' + stepSelector).find(dataSelector + '-roles li').each(function(index) {
			var roleId = $(this).children('.hierarchy-item').attr('id').split('-')[3];
			roles[index] = parseInt(roleId, 10);
		});
		$('#' + stepSelector).find(dataSelector + '-users li').each(function(index) {
			var userId = $(this).children('.hierarchy-item').attr('id').split('-')[3];
			users[index] = parseInt(userId, 10);
		});

		if (type === 'notifications') {
			// Save the values into the approvalProcess object to be used later.
			// we do it this way so that they must click on update deadlines to add notifications.
			// If they click cancel then no changes are made
			if (notificationType === '-deadline') {
				approvalProcessObject.notifyRoleTypes = roleTypes;
				approvalProcessObject.notifyRoles = roles;
				approvalProcessObject.notifyUsers = users;
			} else if(notificationType === '-approve') {
				approvalProcessObject.notifyStepApproveRoleTypes = roleTypes;
				approvalProcessObject.notifyStepApproveRoles = roles;
				approvalProcessObject.notifyStepApproveUsers = users;
				approvalProcessObject.approveEdited = 1;
			} else if(notificationType === '-reject') {
				approvalProcessObject.notifyStepRejectRoleTypes = roleTypes;
				approvalProcessObject.notifyStepRejectRoles = roles;
				approvalProcessObject.notifyStepRejectUsers = users;
				approvalProcessObject.rejectEdited = 1;
			} else if(notificationType === '-mcondition') {
				approvalProcessObject.notifyStepConditionRoleTypes = roleTypes;
				approvalProcessObject.notifyStepConditionRoles = roles;
				approvalProcessObject.notifyStepConditionUsers = users;
			}

		} else if (type === 'pendingRoute') {
			objCustomRoute.updateParticipant(stepSelector);

		} else if (type === 'replace') {


			if (roleTypes.length > 0 || roles.length > 0 || users.length > 0) {

				// remove warning class if need to
				if($('#' + stepSelector).parents('div').parents('div').children('.conflict-resolution-leftContent').hasClass('curriculog-remove-warning-highlight'))
				{
					$('#' + stepSelector).parents('div').parents('div').children('.conflict-resolution-leftContent').removeClass('curriculog-remove-warning-highlight');
					$('#' + stepSelector).parents('div').parents('div').children('.conflict-resolution-rightContent').removeClass('curriculog-remove-warning-highlight');
				}
			}

		} else if (type === 'replaceAll') {

			stepId = '';

			if (roleTypes.length > 0 || roles.length > 0 || users.length > 0) {
				$('#replace-participants-data').find('.conflict-resolution-rightContent').each(function(index) {

					// Copy participants to all of them
					stepId = $(this).find('.replace-participants-data').attr('id');

					// remove warning class if need to
					if ($(this).parents('div').children('.conflict-resolution-leftContent').hasClass('curriculog-remove-warning-highlight')) {
						$(this).parents('div').children('.conflict-resolution-leftContent').removeClass('curriculog-remove-warning-highlight');
						$(this).parents('div').children('.conflict-resolution-rightContent').removeClass('curriculog-remove-warning-highlight');
					}

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

					if (roleTypes.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-role-types').clone().appendTo($('#' +stepId).find(dataSelector + '-role-types'));

						$('#' +stepId).find(dataSelector + '-role-types li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-roleType-' + oldId.split('-')[6]);
						});
					}

					if (roles.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-roles').clone().appendTo($('#' +stepId).find(dataSelector + '-roles'));

						$('#' +stepId).find(dataSelector + '-roles li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-role-' + oldId.split('-')[6]);
						});
					}

					if (users.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-users').clone().appendTo($('#' +stepId).find(dataSelector + '-users'));

						$('#' +stepId).find(dataSelector + '-users li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-user-' + oldId.split('-')[6]);
						});
					}

				});
			} else {
				$('#replace-participants-data').find('.conflict-resolution-rightContent').each(function(index) {

					stepId = $(this).find('.replace-participants-data').attr('id');

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

				});
			}

		} else if (type === 'replaceAllRoleParticipants') {

			stepId = '';

			if (roleTypes.length > 0 || roles.length > 0 || users.length > 0) {
				$('#replace-roleParticipants-data').find('.conflict-resolution-rightContent').each(function(index) {

					// Copy participants to all of them
					stepId = $(this).find('.replace-participants-data').attr('id');

					// remove warning class if need to
					if($(this).parents('div').children('.conflict-resolution-leftContent').hasClass('curriculog-remove-warning-highlight')) {
						$(this).parents('div').children('.conflict-resolution-leftContent').removeClass('curriculog-remove-warning-highlight');
						$(this).parents('div').children('.conflict-resolution-rightContent').removeClass('curriculog-remove-warning-highlight');
					}

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

					if (roleTypes.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-role-types').clone().appendTo($('#' +stepId).find(dataSelector + '-role-types'));

						$('#' +stepId).find(dataSelector + '-role-types li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-roleType-' + oldId.split('-')[6]);
						});
					}

					if (roles.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-roles').clone().appendTo($('#' +stepId).find(dataSelector + '-roles'));

						$('#' +stepId).find(dataSelector + '-roles li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-role-' + oldId.split('-')[6]);
						});
					}

					if (users.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-users').clone().appendTo($('#' +stepId).find(dataSelector + '-users'));

						$('#' +stepId).find(dataSelector + '-users li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', 'replace-participants-data-' + stepId.split('-')[3] + '-user-' + oldId.split('-')[6]);
						});
					}

				});
			} else {
				$('#replace-roleParticipants-data').find('.conflict-resolution-rightContent').each(function(index) {

					stepId = $(this).find('.replace-participants-data').attr('id');

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

				});
			}
		} else {
			// check if crosslisting to see if we need to display warning dialog
			var parentId = $('input[name="parentId"]').val();
			var crosslisted = $('input[name="crosslisted"]').val();
			if (parentId === 0 && crosslisted === 1 && (roles.length > 0 || users.length > 0)) {
				objSelectParticipants.crosslistingWarningDialog(approvalProcessId, stepId, roleTypes, roles, users, stepSelector);
			} else {
				// Update the list of participants.
				objSelectParticipants.updateParticipantsAjax(approvalProcessId, stepId, roleTypes, roles, users, stepSelector, true);
			}
		}
	};

	objSelectParticipants.updateParticipantsAjax = function(approvalProcessId, stepId, roleTypes, roles, users, stepSelector, updateCrosslisting) {
		// Update the list of participants.
		$.ajax({
			url: '/admin/approvalProcessStep:' + approvalProcessId + '/updateStep.json',
			type: 'PUT',
			data: {
				stepId: JSON.stringify(stepId),
				roleTypes: JSON.stringify(roleTypes),
				roles: JSON.stringify(roles),
				users: JSON.stringify(users),
				type: 'participants',
				updateCrosslisting:updateCrosslisting
			},
			beforeSend: function() {
				// Indicate that the step is saving.
				objDom.addMask(stepSelector);
			},
			success: function(data) {

				// Indicate that the step is done saving.
				objDom.removeMask(stepSelector);

				// Adjust the height of the columns.
				approvalProcessObject.verticalStretch();

				// Load in the step.
				approvalProcessObject.updateDOMStep(stepSelector, stepId, 'participants');
			}
		});
	};

	objSelectParticipants.crosslistingWarningDialog = function(approvalProcessId, stepId, roleTypes, roles, users, stepSelector) {
		var dialog = objDialog.createDOMDialog('crosslisting-conflict', function(dialog, defaults) {

			$(dialog).append('<div>This step has specific participants selected that may not apply to a crosslisting and could invalidate a crosslisted proposal\'s ' +
			'workflow. How would you like Curriculog to resolve this conflict?</div>');

			defaults.buttons = {
				'Copy current participants to crosslisting': function() {

					// Update the list of participants.
					objSelectParticipants.updateParticipantsAjax(approvalProcessId, stepId, roleTypes, roles, users, stepSelector, true);

					$(this).empty();
					$(this).dialog('close');
				},
				'Add participants to crosslisting manually': function() {

					objSelectParticipants.updateParticipantsAjax(approvalProcessId, stepId, roleTypes, roles, users, stepSelector, false);

					$(this).empty();
					$(this).dialog('close');
				}
			};

			defaults.width = 800;

			$(dialog).dialog(defaults);

		});
	};

	return objSelectParticipants;
};




/**
 * Object: selectUser
 * Purpose: Choose one user
 */
var selectUser = function() {
	'use strict';

	var objSelectUser = {};

	// Click event for choosing a role-type, role, or user.
	$('#curriculog-steps-column-available-participant').on('click', '.user', function(event) {
		event.preventDefault();
		var itemId = /user-\d+/i.exec($(this).attr('class'));

		// remove all active classes from others
		$('.user').removeClass('active');

		// toggle the selected one
		$('.' + itemId).toggleClass('active');
	});

	// Click event for expanding and contracting the list of entities, roles, users, and role-types.
	$('#curriculog-steps-column-available-participant').on('click', '.toggle-expand', function(event) {
		event.preventDefault();
		$(this).toggleClass('expand-widget').toggleClass('contract-widget').siblings('ul').toggleClass('active');
	});

	$('body').on('click', '.replaceUser', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').parents('div').children('.conflict-resolution-rightContent').children('.replace-user-data').attr('id');
		var userId = $(this).parents('div').parents('div').children('.conflict-resolution-leftContent').children('.replace-user-step-oldUser').attr('id').split('-')[4];

		objSelectUser.userDialog(this, '.curriculog-steps-column-chosen', 'replaceUser', stepId, userId);
	});

	$('body').on('click', '.replaceAllUser', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').children('.replace-user-data').attr('id');
		var userId = $(this).parents('div').children('input[name="replace-user-all-id"]').val();

		objSelectUser.userDialog(this, '.curriculog-steps-column-chosen', 'replaceAllUser', stepId, userId, 'replace-user-data');
	});

	$('body').on('click', '.replaceAllActions', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').children('.replace-user-data').attr('id');
		var userId = $(this).parents('div').children('input[name="replace-user-all-id"]').val();

		objSelectUser.userDialog(this, '.curriculog-steps-column-chosen', 'replaceAllUser', stepId, userId, 'replace-stepAction-data');
	});

	$('body').on('click', '.replaceAllOriginators', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').children('.replace-user-data').attr('id');
		var userId = $(this).parents('div').children('input[name="replace-user-all-id"]').val();

		objSelectUser.userDialog(this, '.curriculog-steps-column-chosen', 'replaceAllUser', stepId, userId, 'replace-originator-data');
	});

	$('body').on('click', '.replaceAllUserInRole', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').children('.replace-user-data').attr('id');
		var userId = $(this).parents('div').children('input[name="replace-user-all-id"]').val();

		objSelectUser.userDialog(this, '.curriculog-steps-column-chosen', 'replaceAllUser', stepId, userId, 'replace-userRole-data');
	});


	/**
	 * Function: participantDialog
	 * Purpose: Load a dialog to allow for entities, roles, users, and role-types to be chosen.
	 */
	objSelectUser.userDialog = function(editSelector, dataSelector, type, stepId, userId, allSelector) {

		var step = stepId;
		var dialogName = 'none';

		var dialog = objDialog.createDOMDialog('curriculog-steps-select-participant', function(dialog, defaults) {

			// Load the list of entities, roles, and users and mark the previously chosen ones.
			$.ajax({
				url: '/entity/hierarchy',
				type: 'GET',
				data: {
					display: JSON.stringify(['entities', 'roles', 'users']),
					branch: JSON.stringify([])
				},
				success: function(data) {
					// Wipe out old data and load in new data.
					$('#curriculog-steps-column-available-roles-and-users').contents().remove();
					$('#curriculog-steps-column-available-roles-and-users').append(data);

					// remove the user from it who is being removed
					//$('.user-15').each(function(index) { console.log($(this).parent('li')); });
					$('.user-' + userId).each(function(index) {
						if ($(this).parent('li').parent('ul').children('li').length === 1 && $(this).parent('li').parent('ul').parents('li').children('ul').length === 1) {
							$(this).parent('li').parent('ul').parent('li').children('a').remove();
							$(this).parent('li').parent('ul').remove();
						} else {
							$(this).parent('li').remove();
						}
					});

					// Prepare for the list of roles and users.
					var users = [];

					// Set the list of roles and users.
					$('#'+ step + ' ' + dataSelector + '-users li').each(function(index) {
						var userId;
						if (type === 'replaceUser') {
							userId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
						} else if (type === 'replaceAllUser') {
							userId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
						}

						users.push(userId);
					});

					// Add an active class to previously selected roles and users.
					for (var i in users) {
						$('#curriculog-steps-column-available-roles-and-users #user-' + users[i]).addClass('active');
						$('#curriculog-steps-column-available-roles-and-users #user-' + users[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-roles-and-users'), 'ul').addClass('active');
					}

					// Modify the toggle icon appropriately.
					$('#curriculog-steps-column-available-roles-and-users ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');
				}
			});

			defaults.buttons = {
				'Select User': function() {

					// Wipe out old data.
					$('#' + step).find(dataSelector + '-role-types').empty();
					$('#' + step).find(dataSelector + '-roles').empty();
					$('#' + step).find(dataSelector + '-users').empty();

					// If the chosen hierarchy item dosent already exist then add it to the list.
					$('#curriculog-steps-column-available-participant .user.active').each(function(index) {

						var chosenUserInStep = step + '-' + $(this).attr('id');

						if ($('#' + chosenUserInStep).length === 0) {
							$(this).clone().attr('id', chosenUserInStep).appendTo($('#' + step).find(dataSelector + '-users')).wrap('<li></li>');
						}
					});

					// Save the participant list.
					objSelectUser.updateUser(step, dataSelector, type, allSelector);

					$(this).dialog('close');
				},
				Cancel: function() { $(this).dialog('close');}
			};

			defaults.width = 800;

			$(dialog).dialog(defaults);

		});
	};


	/*
	 * Function: updateParticipant
	 * Purpose: Loop though the chosen roles, users, and role-types and pass them to the backend.
	 */
	objSelectUser.updateUser = function(stepSelector, dataSelector, type, allSelector) {
		// Set the step Id.
		var stepId = parseInt(stepSelector.split('-')[1], 10);

		// Prepare for the list of role-types, roles, and users.
		var users = [];


		// Set the list of role-types, roles, and users.
		$('#' + stepSelector).find(dataSelector + '-users li').each(function(index) {
			var userId;
			if (type === 'replaceAllUser') {
				userId = $(this).children('.hierarchy-item').attr('id').split('-')[4];
			} else {
				userId = $(this).children('.hierarchy-item').attr('id').split('-')[3];
			}
			users[index] = parseInt(userId, 10);
		});

		if (type === 'replaceUser') {


			if (users.length > 0) {
				// remove warning class if need to
				if ($('#' + stepSelector).parents('div').children('.conflict-step-icon').hasClass('curriculog-remove-warning-highlight')) {
					$('#' + stepSelector).parents('div').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');
				}

				$('#' + stepSelector).parents('div').parents('div').children('.conflict-resolution-leftContent').children('.conflict-proposalName-icon').removeClass('curriculog-remove-warning-highlight');
				$('#' + stepSelector).parents('div').parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');
			}

		} else if (type === 'replaceAllUser') {

			stepId = '';

			if (users.length > 0) {

				$('#' + allSelector).find('.conflict-resolution-rightContent').each(function(index) {

					// Copy participants to all of them
					stepId = $(this).children('.replace-user-data').attr('id');

					// remove warning class if need to
					if ($(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').hasClass('curriculog-remove-warning-highlight')) {
						$(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');
					}

					$(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-proposalName-icon').removeClass('curriculog-remove-warning-highlight');
					$(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

					if (users.length > 0)
					{
						$('#' + stepSelector).find(dataSelector + '-users').clone().appendTo($('#' +stepId).find(dataSelector + '-users'));

						$('#' +stepId).find(dataSelector + '-users li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', allSelector + '-' + stepId.split('-')[3] + '-user-' + oldId.split('-')[6]);
						});
					}

				});
			} else {
				$('#' + allSelector).find('.replace-user-rightContent').each(function(index) {

					stepId = $(this).children('.conflict-resolution-data').attr('id');

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

				});
			}

		}
	};

	return objSelectUser;
};

/**
 * Object: selectCommittee
 * Purpose: Choose from committee's only who have agenda admins
 */
var selectCommittees = function() {
	'use strict';

	var objSelectCommittees = {};

	$('body').on('click', '.replaceRole', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').parents('div').children('.conflict-resolution-rightContent').children('.replace-committees-data').attr('id');

		objSelectCommittees.roleDialog(this, '.curriculog-steps-column-chosen', 'replaceRole', stepId);
	});

	$('body').on('click', '.replaceAllRole', function(event) {
		event.preventDefault();
		var stepId = $(this).parents('div').children('.replace-committees-data').attr('id');
		var roleId = $(this).parents('div').children('input[name="replace-committees-all-id"]').val();

		objSelectCommittees.roleDialog(this, '.curriculog-steps-column-chosen', 'replaceAllRole', stepId, roleId, 'replace-roleParticipants-data');
	});

	objSelectCommittees.bindClickEvents = function() {
		// Click event for choosing a role-type, role, or user.
		$('#curriculog-steps-column-available-participant').on('click', '.role-type, .role', function(event) {
			event.preventDefault();
			var itemId = /role-\d+|role-type-\d+/i.exec($(this).attr('class'));

			// toggle the selected one
			$('.' + itemId).toggleClass('active');
		});

		// Click event for expanding and contracting the list of entities, roles, users, and role-types.
		$('#curriculog-steps-column-available-participant').on('click', '.toggle-expand', function(event) {
			event.preventDefault();
			$(this).toggleClass('expand-widget').toggleClass('contract-widget').siblings('ul').toggleClass('active');
		});
	};

	/**
	 * Function: participantDialog
	 * Purpose: Load a dialog to allow for entities, roles, users, and role-types to be chosen.
	 */
	objSelectCommittees.roleDialog = function(editSelector, dataSelector, type, stepId, userId, allSelector) {

		// bind click events
		objSelectCommittees.bindClickEvents();

		var step = stepId;
		var dialogName = 'none';

		var dialog = objDialog.createDOMDialog('curriculog-steps-select-participant', function(dialog, defaults) {


			// Load the list of role-types and mark the previously chosen ones.
			$.ajax({
				url: '/roleType',
				type: 'GET',
				data: {
					display: 'ajaxRoleTypeList',
					branch: JSON.stringify([]),
					type: 'committee'
				},
				success: function(data) {
					//console.log(data);
					// Wipe out old data and load in new data.
					$('#curriculog-steps-column-available-role-types').contents().remove();
					$('#curriculog-steps-column-available-role-types').append(data);

					// Prepare for the list of role-types.
					var roleTypes = [];

					// Set the list of role-types.
					$('#'+ step + ' ' + dataSelector + '-role-types li').each(function(index) {
						var roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[3];

						if (type === 'replaceRole') {
							roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
						} else if (type === 'replaceAllRole')  {
							roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
						}

						roleTypes.push(roleTypeId);
					});

					// Add an active class to previously selected roles and users.
					for (var i in roleTypes) {
						$('#curriculog-steps-column-available-roles-and-users #roleType-' + roleTypes[i]).addClass('active');
						$('#curriculog-steps-column-available-roles-and-users #roleType-' + roleTypes[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-roles-and-users'), 'ul').addClass('active');
					}

					// Modify the toggle icon appropriately.
					$('#curriculog-steps-column-available-role-types ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');
				}
			});

			// Load the list of entities, roles, and users and mark the previously chosen ones.
			$.ajax({
				url: '/entity/hierarchy',
				type: 'GET',
				data: {
					display: JSON.stringify(['entities', 'roles', 'users']),
					branch: JSON.stringify([]),
					onlyCommittees:true
				},
				success: function(data) {
					// Wipe out old data and load in new data.
					$('#curriculog-steps-column-available-roles-and-users').contents().remove();
					$('#curriculog-steps-column-available-roles-and-users').append(data);

					$('#curriculog-steps-column-available-roles-and-users').find('.user').addClass('noselect');

					// Prepare for the list of roles and users.
					var roles = [];

					// Set the list of roles and users.
					$('#'+ step + ' ' + dataSelector + '-roles li').each(function(index) {
						var roleId;
						if (type === 'replaceRole') {
							roleId = $(this).children('.hierarchy-item').attr('id').split('-')[5];
						} else if(type === 'replaceAllRole') {
							roleId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
						}

						roles.push(roleId);
					});

					// Add an active class to previously selected roles and users.
					for (var i in roles) {
						$('#curriculog-steps-column-available-roles-and-users #role-' + roles[i]).addClass('active');
						$('#curriculog-steps-column-available-roles-and-users #role-' + roles[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($('#curriculog-steps-column-available-roles-and-users'), 'ul').addClass('active');
					}

					// Modify the toggle icon appropriately.
					$('#curriculog-steps-column-available-roles-and-users ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');
				}
			});

			defaults.buttons = {
				'Select Committees': function() {

					// Wipe out old data.
					$('#' + step).find(dataSelector + '-role-types').empty();
					$('#' + step).find(dataSelector + '-roles').empty();
					$('#' + step).find(dataSelector + '-users').empty();

					// If the chosen hierarchy item dosent already exist then add it to the list.
					$('#curriculog-steps-column-available-participant .role.active').each(function(index) {

						var chosenRolesInStep = step + '-' + $(this).attr('id');

						if ($('#' + chosenRolesInStep).length === 0) {
							$(this).clone().attr('id', chosenRolesInStep).appendTo($('#' + step).find(dataSelector + '-roles')).wrap('<li></li>');
						}
					});

					$('#' +stepId).find(dataSelector + '-roles li').each(function(index) {
						$(this).children('.hierarchy-item').children('label').addClass('noDialog');
					});

					// If the chosen hierarchy item dosent already exist then add it to the list.
					$('#curriculog-steps-column-available-participant .role-type.active').each(function(index) {

						var chosenRolesInStep = step + '-' + $(this).attr('id');

						if ($('#' + chosenRolesInStep).length === 0) {
							$(this).clone().attr('id', chosenRolesInStep).appendTo($('#' + step).find(dataSelector + '-role-types')).wrap('<li></li>');
						}
					});

					$('#' +stepId).find(dataSelector + '-role-types li').each(function(index) {
						$(this).children('.hierarchy-item').children('label').addClass('noDialog');
					});

					// Save the participant list.
					objSelectCommittees.updateCommittees(step, dataSelector, type, allSelector);

					$(this).dialog('close');
				},
				Cancel: function() { $(this).dialog('close');}
			};

			defaults.close = function() {
				$('#curriculog-steps-column-available-participant').off('click', '.role-type, .role');
				$('#curriculog-steps-column-available-participant').off('click', '.toggle-expand');
			};

			defaults.width = 800;

			$(dialog).dialog(defaults);

		});
	};


	/*
	 * Function: updateParticipant
	 * Purpose: Loop though the chosen roles, users, and role-types and pass them to the backend.
	 */
	objSelectCommittees.updateCommittees = function(stepSelector, dataSelector, type, allSelector) {

		// Set the step Id.
		var stepId = parseInt(stepSelector.split('-')[1], 10);

		// Prepare for the list of role-types, roles, and users.
		var roles = [];
		var roleTypes = [];


		// Set the list of role-types, roles, and users.
		$('#' + stepSelector).find(dataSelector + '-roles li').each(function(index) {
			var roleId;
			if (type === 'replaceAllRole') {
				roleId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
			} else {
				roleId = $(this).children('.hierarchy-item').attr('id').split('-')[4];
			}
			roles[index] = parseInt(roleId, 10);
		});

		$('#' + stepSelector).find(dataSelector + '-role-types li').each(function(index) {
			var roleTypeId;
			if (type === 'replaceAllRole') {
				roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[6];
			} else {
				roleTypeId = $(this).children('.hierarchy-item').attr('id').split('-')[4];
			}
			roleTypes[index] = parseInt(roleTypeId, 10);
		});

		if (type === 'replaceRole') {


			if (roles.length > 0 || roleTypes.length > 0) {
				// remove warning class if need to
				if ($('#' + stepSelector).parents('div').children('.conflict-step-icon').hasClass('curriculog-remove-warning-highlight')) {
					$('#' + stepSelector).parents('div').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');
				}
			}

		} else if (type === 'replaceAllRole') {

			stepId = '';

			if (roles.length > 0 || roleTypes.length > 0) {

				$('#' + allSelector).find('.conflict-resolution-rightContent').each(function(index) {

					// Copy participants to all of them
					stepId = $(this).children('.replace-committees-data').attr('id');

					// remove warning class if need to
					if ($(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').hasClass('curriculog-remove-warning-highlight')) {
						$(this).parents('div').children('.conflict-resolution-leftContent').children('.conflict-step-icon').removeClass('curriculog-remove-warning-highlight');
					}

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

					if (roles.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-roles').clone().appendTo($('#' +stepId).find(dataSelector + '-roles'));

						$('#' +stepId).find(dataSelector + '-roles li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							console.log(stepId + ' role ' + oldId);
							$(this).children('.hierarchy-item').attr('id', allSelector + '-' + stepId.split('-')[3] + '-role-' + oldId.split('-')[6]);
							$(this).children('.hierarchy-item').children('label').addClass('noDialog');
						});
					}

					if (roleTypes.length > 0) {
						$('#' + stepSelector).find(dataSelector + '-role-types').clone().appendTo($('#' +stepId).find(dataSelector + '-role-types'));

						$('#' +stepId).find(dataSelector + '-role-types li').each(function(index) {
							var oldId = $(this).children('.hierarchy-item').attr('id');
							$(this).children('.hierarchy-item').attr('id', allSelector + '-' + stepId.split('-')[3] + '-role-types-' + oldId.split('-')[6]);
							$(this).children('.hierarchy-item').children('label').addClass('noDialog');
						});
					}

				});
			} else {
				$('#replace-roleParticipants-data').find('.conflict-resolution-rightContent').each(function(index) {

					stepId = $(this).find('.replace-committees-data').attr('id');

					$('#' +stepId).find(dataSelector + '-role-types').empty();
					$('#' +stepId).find(dataSelector + '-roles').empty();
					$('#' +stepId).find(dataSelector + '-users').empty();

				});
			}

		}
	};

	return objSelectCommittees;
};